// extracted by mini-css-extract-plugin
module.exports = {"main":"SocialLinks_main__CGAda","white":"SocialLinks_white__Llt_Z","links-container":"SocialLinks_links-container__AbUT8"};